import BaseEntity from './BaseEntity';
export default class Issue extends BaseEntity {
    constructor(data) {
        super();
        this.endColumn = null;
        this.endLine = null;
        this.nodeType = null;
        this.ruleId = null;
        this.toolVersion = null;
        this.column = this.parseProperty(data, 'column');
        this.endColumn = this.parseProperty(data, 'endColumn');
        this.endLine = this.parseProperty(data, 'endLine');
        this.isError = this.parseProperty(data, 'isError');
        this.line = this.parseProperty(data, 'line');
        this.message = this.parseProperty(data, 'message');
        this.new = this.parseProperty(data, 'new');
        this.nodeType = this.parseProperty(data, 'nodeType');
        this.options = this.parseProperty(data, 'options');
        this.ruleId = this.parseProperty(data, 'ruleId');
        this.severity = this.parseProperty(data, 'severity');
        this.tool = this.parseProperty(data, 'tool');
        this.toolVersion = this.parseProperty(data, 'toolVersion');
    }
}
